import React, { useState } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import tw, { styled } from 'twin.macro'

import ApplicationSlide from "components/application-slide"

const Button = styled.button`
  padding: 4px;
  transition: opacity 0.4s ease;

  opacity: ${props => (props.selected ? "1" : "0.5")};
  height: ${props => (props.selected ? "45px" : "40px")};
  width: ${props => (props.selected ? "45px" : "40px")};

  &:focus {
    outline: none;
  }
`

const ButtonContainer = styled.div`
  ${tw`flex flex-row items-center justify-center`}
  height: 48px;
  width: 48px;
`

const Container = styled.div`
  ${tw`flex flex-col justify-center content-center bg-grey-15`}
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) ${props =>
    ", url('" + props.bg + "')"};
  background-position: center top;
  background-size: cover;
  border-radius: 8px;
  height: 300px;
  margin-bottom: 24px;
  overflow: hidden;
  width: 300px;
  @media (min-width: 640px) {
    height: 490px;
    width: 490px;
  }
`

const SwiperFrame = styled.div`
  opacity: ${props => (props.active ? 1 : 0)};
  transition: opacity 100ms;
  transition-delay: 200ms;
`

const IndustrySlider = ({ data, bg, industry }) => {
  const [slide, setSlide] = useState(0)
  const [active, setActive] = useState(false)
  const [swiper, setSwiper] = useState(null)

  function goTo(idx) {
    if (!active) {
      setActive(true)
    }
    if (swiper) {
      setSlide(idx)
      swiper.slideTo(idx)
    }
  }

  const params = {
    allowTouchMove: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 100,
    width: 300,
    breakpoints: {
      640: {
        width: 490,
        height: 490,
      },
    },
  }
  return (
    <div>
      <Container bg={bg}>
        <SwiperFrame active={active}>
          <Swiper onSwiper={setSwiper} {...params}>
            {data.map((application, idx) => (
              <SwiperSlide key={idx}>
                <div className="flex flex-col items-center">
                  <ApplicationSlide
                    description={application.excerpt.html}
                    icon={
                      <img src={application.icon.url} alt={application.title} />
                    }
                    // @TODO add slug here once CMS updates
                    link={`/industry/${industry.slug}#solutions`}
                    title={application.title}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </SwiperFrame>
      </Container>
    </div>
  )
}

export default IndustrySlider
